import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UiService } from '../models/ui-service';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class Ui {
  // 1	Manage users	Gérer les utilisateur	MANAGE_USERS
  // 2	Manage users	Voir les utilisateur	VIEW_USERS
  // 3	Manage users	Gérer les publicités	MANAGE_ADS
  // 4	Manage users	Voir les publicités	VIEW_ADS
  // 5	Manage users	Gérer les services	MANAGE_SERVICES
  // 6	Manage users	Voir les services	VIEW_SERVICES
  // 7	Manage push notifications	Gérer les push notifications	MANAGE_PUSH_NOTIFICATIONS
  // 8	View push notifications	Voir les push notifications	VIEW_PUSH_NOTIFICATIONS
  // 9	Manage push SETTINGS	Gérer les paramètres	MANAGE_SETTINGS
  // 10	View push notifications	Voir les paramètres	VIEW_SETTINGS
  // 11	Manage Offers	Gérer les offres	MANAGE_OFFERS
  // 12	View Offers	Voir les offres	VIEW_OFFERS
  // 13	Manage Agencies	Gérer les agences	MANAGE_AGENCIES
  // 14	View agencies	Voir les agences	VIEW_AGENCIES
  services: UiService[];
  activatedServices: UiService[] = [];

  avalaiblesServices: UiService[] = [
    new UiService({
      id: 'HOME',
      label: 'Accueil',
      icon: 'home',
      url: '/dash',
    }),
    new UiService({
      id: 'TELCO.OFFER.PROMO.SERVICES',
      label: 'Offres',
      avatar: 'assets/service.png',
      url: '/offres',
      authorizations: []
    }),
    new UiService({
      id: 'TELCO.OFFER.PROMO.SERVICE',
      label: 'Stage/Emploi',
      avatar: 'assets/service.png',
      url: '/stages',
      authorizations: []
    }),
    new UiService({
      id: 'TELCO.OFFER.PROMO.OFFERS',
      label: 'Mes CVs',
      icon: 'clipboard',
      url: '/my-cvs',
      authorizations: ['MANAGE_OFFERS', 'VIEW_OFFERS']
    }),
    new UiService({
      id: 'OFFRES',
      label: 'Mes candidatures',
      icon: 'send',
      url: '/my-candidatutes',
      authorizations: ['MANAGE_SETTINGS', 'VIEW_SETTINGS']
    })
  ];

  constructor(private router: NavController, private settings: StoreService) {
    this.services = <any>this.avalaiblesServices.map(e => {
      e.onClick = () => {
        if (!e.url) {
          return;
        }
        // const hasPermission = () => {
        //   let r = false;
        //   let droit = e.authorizations;
        //   if (!Array.isArray(droit)) {
        //     droit = [droit];
        //   }
        //   console.log('Droit ', droit);
        //   droit.forEach(d => r = r || this.settings.tmp.actions[d]);
        //   return r;
        // };
        if (!this.hasPermission(e)) {
          return;
        }
        return router.navigateForward(e.url, {
          animated: true,
        });
      };
      return e;
    });
  }

  ensurePermission(perm) {
    return this.settings.tmp.actions.includes(perm);
  }
  hasPermission(service: UiService) {
    let r = false;
    let droit = service.authorizations;
    if (!service || !service.authorizations || service.authorizations.length === 0) {
      return true;
    }
    if (!Array.isArray(droit)) {
      droit = [droit];
    }
    console.log('Droit ', droit);
    // droit.forEach(d => r = r || this.settings.tmp.actions.includes(d));
    console.log('Droit ', this.settings.tmp.actions);
    return true;
  }
}
